module.exports = __webpack_public_path__ + "static/img/default_avatar.2f1070ea.png";